import { createStore } from "vuex";

import state from "@/store/state";
import * as mutations from "@/store/mutations";
import * as getters from "@/store/getters";
import * as actions from "@/store/actions";
import { createPersistedState } from "@/utils/persistedState";

import user from "./user";

export default createStore({
  state,
  mutations,
  getters,
  actions,
  modules: {
    user,
  },
  plugins: [
    createPersistedState({
      key: "vuex",
      paths: [
        "user.backendToken",
        "user.isAuthenticated",
        "user.disabledFields.isCollectiveDataFilled",
        "user.disabledFields.isAYCollectiveDataFilled",
        "user.disabledFields.isCitizenRussia",
        "user.disabledFields.isNotStudent",
        "storage",
        "frontVersion",
        "user.isTelegram",
        "statementId",
        "currentCategoryData",
        "individualNominationValue",
        "collectiveNominationValue",
        "granprixNominationValue",
        "AYindividualNominationValue",
        "AYcollectiveNominationValue",
        "AYgranprixNominationValue",
        "portfolioDocId",
        "studentYearCollectiveData",
        "achievementYearCollectiveData",
        "currentCategoryProject",
        "currentCategoryVersion",
        "currentCategoryId",
        "portfolioListLoaded",
        "statementsList",
      ],
    }),
  ],
});
